import React, {useCallback, useEffect, useState} from 'react';
import close from "../../../../images/close.svg";
import infoIcon from '../../../../images/info-circle.svg'
import ReactTooltip from "react-tooltip";
import arrow from '../../../../images/arrow-right.svg'
import {Field, Formik} from "formik";
import arrowDown from "../../../../images/input-arrow.svg";
import closeIcon from '../../../../images/white-close.svg'
import check from '../../../../images/blue-check.svg'
import userCheck from '../../../../images/user-check.svg'
import {useTheme} from "../../../../App";
import {connect} from "react-redux";
import {getCommonData} from "../../../../redux/data/data-thunks";
import {CREW_ROLES} from "../../../../redux/data/data-types";
import {logbookApi} from "../../../../redux/logbook/logbook-api";
import {useTranslation} from "react-i18next";
import TeamMember from "../TripInfo/TeamMember";
import link from '../../../../images/link.svg'

const ShareTrip = ({closeModal, tripId, trip, ...props}) => {
  const [selectedUsers, setSelectedUsers] = useState([])
  const [isCopied, setIsCopied] = useState(false)
  const {t} = useTranslation()
  const friends = [
    // {
    //   name: 'Ronald Richards',
    //   photo: friend1,
    //   email: 'ronald_richards@gmail.com',
    //   role: 'Skipper',
    //   isCheck: true
    // },
    // {
    //   name: 'Darrell Steward',
    //   photo: friend2,
    //   email: 'darrell_steward@gmail.com',
    //   role: 'Crew-member',
    //   isCheck: true
    // },
    // {
    //   name: 'Jenny Wilson',
    //   photo: friend3,
    //   email: 'jenny.wilson@gmail.com',
    //   role: 'Co-Skipper',
    //   isCheck: true
    // },
    // {
    //   name: 'Cameron Williamson',
    //   photo: friend4,
    //   email: 'cameron.williamson@gmail.com',
    //   role: 'Crew-member',
    //   isCheck: false
    // }
  ]
  useEffect(() => {
    props.getCommonData(CREW_ROLES)
  }, [])
  const sendInvitations = useCallback(async () => {
    await logbookApi.sendInvitations(tripId, selectedUsers.map(u => ({email: u.email, role_id: u.role_id})))
  }, [selectedUsers])
  const onSubmit = () => {
    sendInvitations()
    closeModal()
  }
  const {isDark} = useTheme()
  return (
    <div style={{width: 620}} className={`modal pr-40 ${isDark && 'modal__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <div className="modal__row">
        <h5 className="modal__title w-100 modal__row flex-end">
          {t('shareTrip')}
          <button data-tip data-for={'info'} className="modal__infoButton">
            <img src={infoIcon} alt=""/>
          </button>
          <ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={'info'} place="top" effect="solid">
            {t('shareTint')}
          </ReactTooltip>
        </h5>
      </div>
      <div className="modal__content">
        <p className="modal__caption mb-24">{t('recepients')}{selectedUsers.length > 0 && ` (${selectedUsers.length})`}:</p>
        <div className="modal__users mb-24">
          {selectedUsers.map((user, index) => <div className="modal__user" key={index}>
            {user.email}, {user.role}
            <button onClick={() => setSelectedUsers([...selectedUsers].filter(u => user.email !== u.email))}>
              <img src={closeIcon} alt=""/>
            </button>
          </div>)}
        </div>
        <Formik
          initialValues={{
            email: '',
            role: '',
          }}
          onSubmit={({email, role, name}, {resetForm}) => {
            if(selectedUsers.find(u => u.email === email) === undefined) {
              setSelectedUsers([...selectedUsers, {email, role, role_id: props.crewRoles.find(c => c.name === role).id}])
            }
            resetForm()
          }}
        >
          {({handleChange, values, ...formikProps}) => {
            return <div className="modal__inputsRow">
              <div className="modal__inputWrapper w-320">
                <Field value={values.email} onChange={handleChange} id={'email'}
                       placeholder={t('enterRecepientsMail')} type="email" autoComplete={'off'}
                       className="modal__input w-100"/>
                <div className="modal__list">
                  <div className="modal__listItems">
                    {friends.map((friend, index) => <button className={'modal__listItem space-between'} key={index}
                                                            onClick={() => {
                                                              if(!selectedUsers.find(u => u.name === friend.name)) {
                                                                formikProps.setFieldValue('email', friend.email)
                                                              }
                                                            }}>
                      <span className="modal__listRow">
                        <img src={friend.photo} alt=""/>
                      <span className="modal__name">{friend.name}</span>
                      </span>
                      {selectedUsers.find(u => u.name === friend.name) && <img src={check} alt=""/>}
                    </button>)}
                  </div>
                </div>
              </div>
              <div className="modal__inputWrapper w-160">
                <Field value={values.role} id={'role'}
                       placeholder={t('role')} type="text" className="modal__input w-100"/>
                <button className="modal__arrowIcon">
                  <img src={arrowDown} alt=""/>
                </button>
                <div className="modal__list">
                  <div className="modal__listItems">
                    {props.crewRoles.map((role, index) => <button onClick={() => formikProps.setFieldValue('role', role.name)}
                                                        key={index}
                                                        className={'modal__listItem'}>
                      <span className="modal__name">{role.name}</span>
                    </button>)}
                  </div>
                </div>
              </div>
              <button onClick={formikProps.handleSubmit} className="modal__send">
                <img src={arrow} alt=""/>
              </button>
            </div>
          }}
        </Formik>
        <div>
          <button onClick={() => {
            navigator.clipboard.writeText('google.com')
            setIsCopied(true)
          }} className={'modal__link'}>
            <img src={isCopied ? check : link} alt=""/>
            {t('inviteByLink')}
          </button>
        </div>
        <div className="modal__friends">
          {trip.team?.map?.((friend, index) => <TeamMember user={friend} key={index} />)}
        </div>
      </div>
      <div className="modal__actions mt-24">
        <button onClick={onSubmit} disabled={selectedUsers.length === 0}
                className={`submit-button ${selectedUsers.length === 0 && 'submit-button__disabled'}`}>
          {t('share')}
        </button>
        <button onClick={closeModal} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
          <span className={'commonBtn__label'}>{t('cancel')}</span>
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  crewRoles: state.dataReducer.crewRoles
})

export default connect(mapStateToProps, {getCommonData})(React.memo(ShareTrip))
